import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import { useEffect, useRef } from "react";

import { Spinner } from "../../../../../../components/ui";
import { UPDATE_ARTWORK as updateArtworkMutation } from "../../../../../../graphql/mutation/Artwork";
import { FETCH_ARTWORK as fetchArtwork } from "../../../../../../graphql/query/Artwork";
import { getChangedFields } from "../../../../../../util";
import ArtworkPrecis from "../../../../../Artwork/pages/Wizard/pages/Precis";

const SHARED_PRECIS_WARNING =
  "Editing the precis changes it for every instance of this artwork.";

// Reuses the Artwork "Precis" page, bound to this instance's parent artwork via
// artworkId (the same way the Offers page is shared onto instances). Edits are
// saved straight onto the artwork, so a shared-edit warning is shown.
const InstancePrecis = (props = {}) => {
  const { artworkId } = props;
  const abortController = useRef();

  const { data: { artwork } = {}, loading } = useQuery(
    fetchArtwork({ precis: true }),
    {
      skip: !artworkId,
      variables: { id: +artworkId },
    },
  );

  const [updateArtwork] = useMutation(updateArtworkMutation());

  const formik = useFormik({
    initialValues: artwork || {},
    enableReinitialize: true,
    onSubmit: values => {
      const changedFields = getChangedFields(values, artwork || {});

      if (Object.keys(changedFields).length > 0) {
        const controller = new AbortController();
        abortController.current = controller;

        updateArtwork({
          variables: {
            input: {
              id: +artworkId,
              ...changedFields,
            },
          },
          context: {
            fetchOptions: {
              signal: controller.signal,
            },
          },
        });
      }
    },
  });

  useEffect(() => {
    if (formik?.values && abortController?.current) {
      abortController.current.abort();
    }
  }, [formik?.values]);

  if (loading) {
    return (
      <div className="flex w-full items-center justify-center py-12">
        <Spinner />
      </div>
    );
  }

  return <ArtworkPrecis formik={formik} note={SHARED_PRECIS_WARNING} />;
};

export default InstancePrecis;
